import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

const T = {
  it: {
    loading: "Verifica in corso…",
    ok_title: "Iscrizione confermata",
    ok_txt: "Grazie! Ti scriveremo esclusivamente per aggiornarti sul mondo BioNutrix.",
    err_title: "Link non valido",
    err_txt: "Il link di conferma non è valido o è scaduto. Puoi provare a iscriverti nuovamente.",
    home: "Torna alla home",
  },
  en: {
    loading: "Verifying…",
    ok_title: "Subscription confirmed",
    ok_txt: "Thank you! We will only write to update you about the BioNutrix world.",
    err_title: "Invalid link",
    err_txt: "The confirmation link is invalid or expired. You can try subscribing again.",
    home: "Back to home",
  },
};

export default function NewsletterConfirmPage() {
  const { lang } = useI18n();
  const c = T[lang];
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.get("/newsletter/confirm", { params: { token } }).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, [params]);

  return (
    <div className="mx-auto max-w-2xl px-6 py-24 text-center" data-testid="newsletter-confirm-page">
      {status === "loading" && <p className="text-muted-ink">{c.loading}</p>}
      {status === "ok" && (
        <>
          <h1 className="font-display text-5xl text-brand mb-4">{c.ok_title}</h1>
          <p className="text-muted-ink mb-8">{c.ok_txt}</p>
          <Link to="/" className="inline-block rounded-full bg-brand text-white px-6 py-3 text-sm">{c.home}</Link>
        </>
      )}
      {status === "error" && (
        <>
          <h1 className="font-display text-5xl text-brand mb-4">{c.err_title}</h1>
          <p className="text-muted-ink mb-8">{c.err_txt}</p>
          <Link to="/" className="inline-block rounded-full bg-brand text-white px-6 py-3 text-sm">{c.home}</Link>
        </>
      )}
    </div>
  );
}
